export default __webpack_public_path__ + "static/media/lifepharmacy.3af3b3c0.png";